import { useEffect, useState } from 'react';
import { getEnrollmentStudentDirectory, getStudentOpenInstallments } from '../../api/endpoints/sponte';
import { loadEnrollmentStudent } from './enrollmentStudentSearch';

export function useEnrollmentStudents(isPreMatricula) {
  const [students, setStudents] = useState([]);
  const [listLoading, setListLoading] = useState(true);
  const [listError, setListError] = useState('');
  const [listAttempt, setListAttempt] = useState(0);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentData, setStudentData] = useState(null);
  const [studentLoading, setStudentLoading] = useState(false);
  const [studentError, setStudentError] = useState('');
  const [financialStatus, setFinancialStatus] = useState(null);
  const [financialLoading, setFinancialLoading] = useState(false);
  const [financialError, setFinancialError] = useState('');

  useEffect(() => {
    const controller = new AbortController();
    setStudents([]);
    setListLoading(true);
    setListError('');
    setSelectedStudent(null);
    getEnrollmentStudentDirectory(2026, isPreMatricula ? 6 : 1,
      { signal: controller.signal }, listAttempt > 0)
      .then((rows) => {
        if (!controller.signal.aborted) {
          if (!Array.isArray(rows)) throw new Error('Resposta inválida');
          setStudents(rows);
        }
      })
      .catch(() => {
        if (!controller.signal.aborted) setListError('Não foi possível carregar a lista de alunos. Tente novamente.');
      })
      .finally(() => { if (!controller.signal.aborted) setListLoading(false); });
    return () => controller.abort();
  }, [isPreMatricula, listAttempt]);

  useEffect(() => {
    const controller = new AbortController();
    setStudentData(null);
    setStudentError('');
    setFinancialStatus(null);
    setFinancialError('');
    setStudentLoading(Boolean(selectedStudent));
    setFinancialLoading(Boolean(selectedStudent));
    if (selectedStudent) {
      loadEnrollmentStudent(selectedStudent, controller.signal)
        .then((data) => { if (!controller.signal.aborted) setStudentData(data); })
        .catch(() => {
          if (!controller.signal.aborted) setStudentError('Não foi possível carregar os dados do aluno e dos responsáveis. Tente novamente.');
        })
        .finally(() => { if (!controller.signal.aborted) setStudentLoading(false); });
      getStudentOpenInstallments(selectedStudent.AlunoID, { signal: controller.signal })
        .then((status) => { if (!controller.signal.aborted) setFinancialStatus(status); })
        .catch(() => {
          if (!controller.signal.aborted) setFinancialError('Não foi possível verificar as pendências financeiras neste momento. O requerimento pode continuar.');
        })
        .finally(() => { if (!controller.signal.aborted) setFinancialLoading(false); });
    } else {
      setFinancialLoading(false);
    }
    return () => controller.abort();
  }, [selectedStudent]);

  return {
    students, listLoading, listError, selectedStudent, setSelectedStudent,
    studentData, studentLoading, studentError,
    financialStatus, financialLoading, financialError,
    retryList: () => setListAttempt((attempt) => attempt + 1),
    retryStudent: () => setSelectedStudent((student) => student ? { ...student } : null),
  };
}
